import React from 'react'

import { ZariContext } from '_zari/context'

import { Button, Table, Modal, Divider, Row, Col } from '_zari/core'

import { IdGen } from 'utils'

import * as PlantillaCobranzaService from 'services/plantillaCobranza.service'

import * as Sections from './sections'

const PlantillaCobranzaCrudModal = ({ handleClose, show, idSocio }) => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarSection, setMostrarSection] = React.useState(false)
  const [keySection, setKeySection] = React.useState(IdGen.newId())

  const tableRef = React.useRef()

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      PlantillaCobranzaService.eliminarxId(_id)
        .then(() => {
          tableRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickNuevaPartida = React.useCallback(() => {
    setMostrarSection(true)
    setKeySection(IdGen.newId())
  }, [])

  const cancelOperation = React.useCallback(() => {
    setMostrarSection(false)
    setKeySection(IdGen.newId())
  }, [])

  const reloadTable = React.useCallback(() => {
    tableRef.current.reload()
    setMostrarSection(false)
    setKeySection(IdGen.newId())
  }, [])

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>PLANTILLAS COBRANZA</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!mostrarSection && (
          <Row>
            <Col md={12} className='text-right'>
              <Button onClick={clickNuevaPartida}>Nueva Plantilla</Button>
            </Col>
          </Row>
        )}
        {mostrarSection && (
          <Sections.CrearEditarSection
            key={keySection}
            cancelOperation={cancelOperation}
            reloadTable={reloadTable}
          />
        )}
        <Divider />
        <Table.ServerSide
          useNest={true}
          ref={tableRef}
          url='/plantillas-cobranza'
          rowsPerPage={4}
          headRows={[{ label: 'CUENTA CONTABLE' }, { label: 'MONEDA' }, { label: '' }]}
          rowTemplate={row => (
            <Table.Row>
              <Table.Cell>{row.cuentaContable || '--'}</Table.Cell>
              <Table.Cell>{row.moneda || '--'}</Table.Cell>
              <Table.Cell>
                <Table.Dropdown>
                  {({ handleClose }) => [
                    <Table.Dropdown.Item
                      key='eliminar'
                      handleClose={handleClose}
                      onClick={e => clickEliminar({ _id: row._id })}
                    >
                      Eliminar
                    </Table.Dropdown.Item>
                  ]}
                </Table.Dropdown>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(PlantillaCobranzaCrudModal)
